import React from "react";
import { Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import GetParsedDate from "../../shared/GetParsedDate";
const DisplayEmail = ({ email, moamad }) => {
  return (
    <>
      <div className="card container p-3 my-3 border" id="mail-card">
        <div className="card-header">
          <h3 style={{ textAlign: "center" }}>
            הודעת דואר אלקטרוני של: {moamad?.f_name}{" "}
            {moamad?.father_name ? moamad?.father_name + " " : ""}{" "}
            {moamad?.l_name}
          </h3>
        </div>
        <div className="card-body">
          <Row className="mt-4">
            <Col>
              <label htmlFor="id"> מספר ההודעה: </label>
              <div style={{ border: "1px solid gray" }}>{email?.id}</div>
            </Col>
            <Col>
              <label htmlFor="id"> ההודעה נשלחה ע"י: </label>
              <div style={{ border: "1px solid gray" }}>{email?.sender}</div>
            </Col>
            <Col>
              <label htmlFor="id"> תאריך וזמן שליחת ההודעה: </label>
              <div style={{ border: "1px solid gray" }}>
                {GetParsedDate({ strDate: email?.send_date, withTime: true })}
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <label htmlFor="id"> סוג ההודעה: </label>
            <div style={{ border: "1px solid gray" }}>{email?.mail_type}</div>
          </Row>
          <Row className="mt-4">
            <label htmlFor="id"> תוכן ההודעה: </label>
            <div style={{ border: "1px solid gray" }}>
              {parse(email?.content ? email?.content : "")}
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};

export default DisplayEmail;
